import { render, staticRenderFns } from "./facebook.vue?vue&type=template&id=4f6bbd4a&scoped=true&"
import script from "./facebook.vue?vue&type=script&lang=js&"
export * from "./facebook.vue?vue&type=script&lang=js&"
import style0 from "./facebook.vue?vue&type=style&index=0&id=4f6bbd4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6bbd4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/UejMkTXs/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f6bbd4a')) {
      api.createRecord('4f6bbd4a', component.options)
    } else {
      api.reload('4f6bbd4a', component.options)
    }
    module.hot.accept("./facebook.vue?vue&type=template&id=4f6bbd4a&scoped=true&", function () {
      api.rerender('4f6bbd4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/videos/_components/facebook.vue"
export default component.exports